import store from 'store';

export function save(state) {
    store.set('state', state);
}

export function getState() {
    return store.get('state');
}
